<template>
	<div style="width: 100%;background: #fff;height: 600px;" class="d-flex m-2">
		<div style="width: 48%;margin-right: 2%;" class="m-1">
			<div>
				<el-button type="primary" size="mini" icon="el-icon-search">查询</el-button>
				<el-button type="success" size="mini" icon="el-icon-bottom">导出</el-button>
			</div>
			<div>
				<el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
					<el-menu-item index="1">待销售出库的产品</el-menu-item>
					<el-menu-item index="2">已销售出库的产品</el-menu-item>
				</el-menu>
			</div>
			<div>
				<el-table class="mt-3" :data="tableData" style="width: 100%" size="mini">
					<el-table-column align="center" prop="id" width="60" label="编号"></el-table-column>
					<el-table-column align="center" prop="cpmc" width="160" label="产品名称"></el-table-column>
					<el-table-column align="center" prop="cpbm" label="产品编码"></el-table-column>
					<el-table-column align="center" prop="ggmc" label="规格名称"></el-table-column>
					<el-table-column align="center" prop="ggbm" label="规格编码"></el-table-column>
					<el-table-column align="center" prop="sl" label="数量"></el-table-column>
					<el-table-column align="center" prop="dw" label="单位"></el-table-column>
				</el-table>
			</div>
		</div>
		<div style="width: 50%;" class="m-1">
			<div style="font-weight: 800;">产品统计</div>
			<div ref="myCharta" style="width: 100%; height: 580px;"></div>
		</div>
	</div>
</template>

<script>
import 'echarts/map/js/china.js';
import * as vueEcharts from 'echarts';
let echarts = require('echarts');
export default {
	data() {
		return {
			activeIndex: '1',
			myChart: null,
			lista:[],
			listb:[],
			tableData: [],
			onea:[],
			twoa:[],
			oneb:[],
			twob:[],
			ta:[],
			tb:[]
		};
	},
	mounted() {
		// 画统计图
		this.drawLine();
		this.axios.get('/admin/xxmxb',{
			token: true
		}).then(res => {
			this.lista = res.data.data
			this.tableData = this.lista
			this.onea = this.lista.map(i => {
				return i.cpmc;
			});
			this.oneb = this.lista.map(i => {
				return i.sl;
			});
			this.ta = this.onea
			this.tb = this.oneb
		})
		this.axios.get('/admin/xxmxbs',{
			token: true
		}).then(res => {
			this.listb = res.data.data
			this.twoa = this.listb.map(i => {
				return i.cpmc;
			});
			this.twob = this.listb.map(i => {
				return i.sl;
			});
		})
		
	},
	methods: {
		handleSelect(key) {
			console.log(key)
			if(key == 2){
				this.ta = this.twoa
				this.tb = this.twob
				this.tableData = this.listb
				this.drawLine();
			}else{
				this.tableData = this.lista
				this.ta = this.onea
				this.tb = this.oneb
				this.drawLine();
			}
		},
		drawLine() {
			// 初始化echarts实例
			let myCharta = echarts.init(this.$refs.myCharta);
			var that = this;
			setTimeout(function() {
				// 配置参数
				myCharta.setOption({
					tooltip: {
						trigger: 'axis',
						axisPointer: {
							type: 'shadow'
						}
					},
					legend: {},
					grid: {
						left: '3%',
						right: '4%',
						bottom: '3%',
						containLabel: true
					},
					xAxis: {
						type: 'value',
						boundaryGap: [0, 0.01]
					},
					yAxis: {
						type: 'category',
						data: that.ta
					},
					series: [
						{
							name: '2022',
							type: 'bar',
							data: that.tb
						}
					]
				});
			}, 1000);
		}
	}
};
</script>

<style></style>
